<script>
import { mapState } from 'vuex'
import fromPairs from 'lodash/fromPairs'
import date from 'locutus/php/datetime/date'
import {
  fetchGrantMemberList,
  createGrantMember,
  deleteGrantMember,
  fetchGrants,
} from '@apis/admin/acs'

export default {
  props: {
    member_seq: {
      default: 0,
      type: [String, Number],
    },
  },
  data() {
    return {
      grants: [],
      member_grants: [],
      s_grant_seq: null,
      loading: false,
    }
  },
  computed: {
    ...mapState('common', {
      constants: (state) => state.constants,
    }),
  },
  mounted() {
    this.init()
  },
  methods: {
    init() {
      this.loading = true
      Promise.all([this.loadGrants(), this.loadMemberGrants()])
        .catch((e) => this.$toasted.error(e.message))
        .finally(() => {
          this.loading = false
        })
    },
    async loadGrants() {
      const { data } = await fetchGrants()

      this.grants = data
    },
    async loadMemberGrants() {
      const { data } = await fetchGrantMemberList({
        member_seq: this.member_seq,
        no_paging: 1,
      })

      this.member_grants = data
    },
    async handleCreate() {
      this.loading = true
      try {
        await createGrantMember({
          member_seq: this.member_seq,
          grant_seq: this.s_grant_seq,
        })

        this.$notify({
          title: this.$t('toasted_msg.title'),
          message: this.$t('member_acs_grant.msg_successfully'),
          type: 'success',
        })

        this.init()
      } catch (e) {
        this.$toasted.error(e.message)
      } finally {
        this.loading = false
      }
    },
    async handleDelete(seq) {
      this.loading = true
      try {
        await deleteGrantMember(seq)

        this.$notify({
          title: this.$t('toasted_msg.title'),
          message: this.$t('member_acs_grant.msg_revoked'),
          type: 'success',
        })

        this.init()
      } catch (e) {
        this.$toasted.error(e.message)
      } finally {
        this.loading = false
      }
    },
    fromPairs,
    date,
  },
}
</script>

<template>
  <div v-loading="loading">
    <h3 :class="$style.xeAdmin">{{
      $t('member_acs_grant.member_applied_acs')
    }}</h3>
    <form @submit.prevent="handleCreate">
      <fieldset>
        <select v-model="s_grant_seq">
          <option v-if="grants.length" :value="null">{{
            $t('member_acs_grant.msg_select_acs')
          }}</option>
          <option v-else :value="null" :disabled="true">{{
            $t('member_acs_grant.msg_not_exist')
          }}</option>
          <option v-for="item in grants" :key="item.seq" :value="item.seq">{{
            item.title
          }}</option>
        </select>
        {{ ' ' }}
        <span
          href="#"
          :class="[$style.button, $style.black]"
          @click.prevent="handleCreate"
          ><input type="submit" :value="$t('member_acs_grant.application')"
        /></span>
      </fieldset>
    </form>
    <table cellspacing="0" cellpadding="0" :class="$style.crossTable">
      <thead>
        <tr>
          <th scope="col"
            ><div>{{ $t('member_acs_grant.privilege_name') }}</div></th
          >
          <th scope="col"
            ><div>{{ $t('member_acs_grant.permission_title') }}</div></th
          >
          <th scope="col"
            ><div>{{ $t('admin.regdate') }}</div></th
          >
          <th scope="col"><div>&nbsp;</div></th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="item in member_grants" :key="item.seq">
          <td :class="[$style.tCenter, $style.nowrap]">{{
            item.grant_name
          }}</td>
          <td :class="[$style.wide]">{{ item.grant_title }}</td>
          <td :class="[$style.tCenter, $style.nowrap]">{{
            date('Y-m-d H:i:s', new Date(item.regdate))
          }}</td>
          <td :class="[$style.tRight, $style.nowrap]">
            <a
              href="#"
              :class="[$style.button, $style.red]"
              @click.prevent="handleDelete(item.seq)"
              ><span>{{ $t('admin.delete') }}</span></a
            >
          </td>
        </tr>
        <tr v-if="!member_grants.length">
          <td :colspan="5" :class="$style.tCenter">{{
            $t('member_acs_grant.msg_not_have')
          }}</td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<style lang="scss" module>
@import '@src/design/default.scss';
@import '@src/design/admin.scss';
@import '@src/design/font.scss';
@import '@src/design/button.scss';
</style>
